import axios from "axios";
import configHeaders from "../../config/HeadersNetwork";

const searchSupportRequest = async (params) => {
    try {
        const { data } = await axios.get(`${process.env.REACT_APP_HOST_WEB}support-result`, {
            params,
            ...configHeaders(),
        });
        return data;
    } catch (error) {
        throw error;
    }
};

const supportLookupWebService = {
    searchSupportRequest,
};

export default supportLookupWebService;
